import { useContext } from 'react';
import Typography from '@mui/material/Typography';
import { AssetGroupContext } from '../../AssetGroup/assetGroupContextWrapper';
import { NavLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import EllipsisTypography from '../../EllipsisTypography/EllipsisTypography';

function GroupsBreadcrumb({ groupId, redirectTo = '/groups' }) {
  const theme = useTheme();

  const { assetGroups, assetGroupsLoading } = useContext(AssetGroupContext);

  if (!groupId) return null;

  const selectedAssetGroup = assetGroups?.find(group => group.id === groupId);

  if (assetGroupsLoading) {
    return <Typography variant="body2">Loading...</Typography>;
  }

  if (!selectedAssetGroup?.name) return null;

  return (
    <NavLink
      to={`${redirectTo}?groupId=${groupId}`}
      style={{
        cursor: 'pointer',
        textDecoration: 'none',
        color: theme.palette.blue.link
      }}
    >
      <EllipsisTypography>{selectedAssetGroup.name}</EllipsisTypography>
    </NavLink>
  );
}

export default GroupsBreadcrumb;
